import styled from 'styled-components';
import { Checkbox, InputField } from '@cashfree-intl/coherent';

import { Popup } from 'components/Common';

export const StyledPopup = styled(Popup)`
  &.ui.popup {
    border: none;
    padding: 0;
    min-width: 18.75rem;
    margin-top: 0.375rem;

    &:before {
      display: none;
    }
  }
`;

export const StyledPopoverTrigger = styled.div`
  position: relative;
  width: max-content;
`;

export const StyledCTAWrapper = styled.div`
  border-top: 1px solid #e6e9ee;
  position: sticky;
  bottom: 0;
  background: white;
`;

export const StyledPopupContent = styled.div`
  max-height: 480px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: ${props => props.theme.SCROLL_BAR_WIDTH.small};
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-track {
    background: var(--BACKGROUND_LIGHT);
  }
  &::-webkit-scrollbar-thumb {
    background: var(--SECONDARY_LIGHTER);
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  min-height: unset !important;
`;

export const StyledInputField = styled(InputField)`
  .ui.fluid.input {
    margin-bottom: 0 !important;
    width: 20rem;
  }
`;
